import { useTranslation, hfbXxxStringTranslator } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  RowVisibility,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import hfbNumbers from "@coworker/app/src/components/InputPopup/UserFiltersRow/hfbNumbers.json";
import { otherLocationsList } from "../constants";

export const LOCATION_ID = "location";

export const DEFUALT_LOCATION_VALUE: FilterValue = {
  filterId: LOCATION_ID,
  value: "whole=whole",
};

export function useLocationFilter(): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = DEFUALT_LOCATION_VALUE;

  const hfbs = hfbNumbers.map((hfb) => ({
    value: `depts=${hfb}`,
    title:
      t(`hfbFilterOptionString`, { hfb }) +
      " - " +
      hfbXxxStringTranslator(hfb, t),
  }));

  const otherLocations = otherLocationsList.map((location) => ({
    value: `other=${location.value}`,
    title: t(location.transKey),
  }));

  return {
    inputType: InputType.Select,
    filterType: FilterType.Filter,
    id: LOCATION_ID,
    title: t("location3String"),
    options: [
      {
        title: t("wholeStoreString"),
        value: "whole=whole",
      },
      {
        title: t("hfbString"),
        options: hfbs,
      },
      {
        title: t("otherString"),
        options: otherLocations,
      },
    ],
    enabled: true,
    defaultValue,
    rowVisibility: RowVisibility.PillOnly,
  };
}
